import { render, staticRenderFns } from "./GenericSwitch.vue?vue&type=template&id=2c76ed47&scoped=true"
import script from "./GenericSwitch.vue?vue&type=script&lang=js"
export * from "./GenericSwitch.vue?vue&type=script&lang=js"
import style0 from "./GenericSwitch.vue?vue&type=style&index=0&id=2c76ed47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76ed47",
  null
  
)

export default component.exports